import { render, staticRenderFns } from "./AppReview.vue?vue&type=template&id=5ab1aa8e&scoped=true"
import script from "./AppReview.vue?vue&type=script&lang=js"
export * from "./AppReview.vue?vue&type=script&lang=js"
import style0 from "./AppReview.vue?vue&type=style&index=0&id=5ab1aa8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab1aa8e",
  null
  
)

export default component.exports